import { getLotusProviderIconUrl } from '../../utils/lotusProviderIcons'
import type { PkCatalogBanner, PkCatalogCategory, PkCatalogProvider } from './playKaroCasinoCatalogTypes'

const ICON = '/imgs/playkaro/slots/providers'

export const PK_SLOT_BANNERS: readonly PkCatalogBanner[] = [
  { src: '/imgs/playkaro/slots/banners/pigaboom.webp', alt: 'Pigaboom' },
  { src: '/imgs/playkaro/slots/banners/reel_fin_fury.jpg', alt: 'Reel Fin Fury' },
  { src: '/imgs/playkaro/slots/banners/astronaut_go.jpg', alt: 'Astronaut GO' },
  { src: '/imgs/playkaro/slots/banners/aviatrix_mines.jpg', alt: 'Aviatrix Mines' },
  { src: '/imgs/playkaro/slots/banners/jeetexch_rump.jpg', alt: 'Jeetexch' },
  { src: '/imgs/playkaro/slots/banners/citrus_splash_deluxe.jpg', alt: 'Citrus Splash Deluxe' },
  { src: '/imgs/playkaro/slots/banners/aviatrix_second.jpg', alt: 'Aviatrix Second Chance' },
  { src: '/imgs/playkaro/slots/banners/skyward_deluxe.webp', alt: 'Skyward Deluxe' },
  { src: '/imgs/playkaro/slots/banners/vortex.webp', alt: 'Vortex' },
  { src: '/imgs/playkaro/slots/banners/chicken_road.webp', alt: 'Chicken Road' },
  { src: '/imgs/playkaro/slots/banners/aviator.webp', alt: 'Aviator' },
  { src: '/imgs/playkaro/slots/banners/spinwin.jpg', alt: 'Spin Win' },
]

export const PK_SLOT_CATEGORIES: readonly PkCatalogCategory[] = [
  { id: 'all', label: 'All' },
  { id: 'new', label: 'New' },
  { id: 'cricket', label: 'Cricket', rx: /cricket/i },
  { id: 'crash', label: 'Crash Game', rx: /crash|aviator|jetx|spribe|limbo|chicken|balloon|plinko|mines|aviator/i },
  { id: 'jackpots', label: 'Jackpots', rx: /jackpot|jack\s?pot/i },
  { id: 'top_rated', label: 'Top Rated' },
  { id: 'table', label: 'Table', rx: /table|roulette|blackjack|poker|baccarat|sic\s?bo/i },
  { id: 'fishing', label: 'Fishing', rx: /fish|fishing|hunter|fisherman/i },
]

export const PK_SLOT_SEED_PROVIDERS: readonly PkCatalogProvider[] = [
  { id: 'all', label: 'ALL', icon: `${ICON}/all.webp` },
  { id: 'spribe', label: 'SPRIBE', icon: `${ICON}/spribe.png`, rx: /spribe/i },
  { id: 'pigaboom', label: 'PIGABOOM', icon: `${ICON}/pigaboom.png`, rx: /pigaboom/i },
  { id: 'aviatrix', label: 'AVIATRIX', icon: `${ICON}/aviatrix.png`, rx: /aviatrix/i },
  { id: 'redtiger', label: 'RED TIGER', icon: `${ICON}/redtiger.png`, rx: /red\s?tiger/i },
  { id: 'netent', label: 'NETENT', icon: `${ICON}/netent.png`, rx: /netent/i },
  { id: 'pgsoft', label: 'PGSOFT', icon: `${ICON}/pgsoft.png`, rx: /pg\s?soft|pgsoft/i },
  { id: '1spin4win', label: '1SPIN4WIN', icon: `${ICON}/1spin4win.png`, rx: /1spin4win|1\s?spin/i },
  { id: '5men', label: '5MEN', icon: `${ICON}/5men.png`, rx: /5\s?men/i },
  { id: '7mojos', label: '7MOJOS', icon: `${ICON}/7mojos.png`, rx: /7\s?mojos|mojos/i },
  { id: '7rings', label: '7RINGS', icon: `${ICON}/7rings.png`, rx: /7\s?rings/i },
  { id: 'apparat', label: 'APPARAT', icon: `${ICON}/apparat.png`, rx: /apparat/i },
  { id: 'belatra', label: 'BELATRA', icon: `${ICON}/belatra.png`, rx: /belatra/i },
  { id: 'betongames', label: 'BETONGAMES', icon: `${ICON}/betongames.png`, rx: /beton/i },
  { id: 'bgames', label: 'BGAMES', icon: `${ICON}/bgames.png`, rx: /\bbgames\b/i },
  { id: 'bgaming', label: 'BGAMING', icon: `${ICON}/bgaming.png`, rx: /bgaming/i },
  { id: 'booming', label: 'BOOMING', icon: `${ICON}/booming.png`, rx: /booming/i },
  { id: 'bsg', label: 'BSG', icon: `${ICON}/bsg.png`, rx: /\bbsg\b/i },
  { id: 'clawbuster', label: 'CLAWBUSTER', icon: `${ICON}/clawbuster.png`, rx: /clawbuster/i },
  { id: 'dreamplay', label: 'DREAMPLAY', icon: `${ICON}/dreamplay.png`, rx: /dreamplay/i },
  { id: 'endorphina', label: 'ENDORPHINA', icon: `${ICON}/endorphina.png`, rx: /endorphina/i },
  { id: 'everymatrix', label: 'EVERYMATRIX', icon: `${ICON}/everymatrix.png`, rx: /everymatrix/i },
  { id: 'evoplay', label: 'EVOPLAY', icon: `${ICON}/evoplay.png`, rx: /evoplay/i },
  { id: 'fazi', label: 'FAZI', icon: `${ICON}/fazi.png`, rx: /fazi/i },
  { id: 'fbastards', label: 'FBASTARDS', icon: `${ICON}/fbastards.png`, rx: /fbastards|fat\s?panda/i },
  { id: 'formulaspin', label: 'FORMULASPIN', icon: `${ICON}/formulaspin.png`, rx: /formulaspin/i },
  { id: 'fugaso', label: 'FUGASO', icon: `${ICON}/fugaso.png`, rx: /fugaso/i },
  { id: 'gameart', label: 'GAMEART', icon: `${ICON}/gameart.png`, rx: /gameart/i },
  { id: 'gamzix', label: 'GAMZIX', icon: `${ICON}/gamzix.png`, rx: /gamzix/i },
  { id: 'ggames', label: 'GGAMES', icon: `${ICON}/ggames.png`, rx: /\bggames\b/i },
  { id: 'habanero', label: 'HABANERO', icon: `${ICON}/habanero.png`, rx: /habanero/i },
  { id: 'hacksaw', label: 'HACKSAW', icon: `${ICON}/hacksaw.png`, rx: /hacksaw/i },
  { id: 'inout', label: 'INOUT', icon: `${ICON}/inout.png`, rx: /inout/i },
  { id: 'jacktop', label: 'JACKTOP', icon: `${ICON}/jacktop.png`, rx: /jacktop/i },
  { id: 'jdb', label: 'JDB', icon: `${ICON}/jdb.png`, rx: /\bjdb\b/i },
  { id: 'kagaming', label: 'KAGAMING', icon: `${ICON}/kagaming.png`, rx: /ka\s?gaming|kagaming/i },
  { id: 'kalamba', label: 'KALAMBA', icon: `${ICON}/kalamba.png`, rx: /kalamba/i },
  { id: 'kendoo', label: 'KENDOO', icon: `${ICON}/kendoo.png`, rx: /kendoo/i },
  { id: 'lambdagaming', label: 'LAMBDA', icon: `${ICON}/lambdagaming.png`, rx: /lambda/i },
  { id: 'mancala', label: 'MANCALA', icon: `${ICON}/mancala.png`, rx: /mancala/i },
  { id: 'mascot', label: 'MASCOT', icon: `${ICON}/mascot.png`, rx: /mascot/i },
  { id: 'mrslotty', label: 'MRSLOTTY', icon: `${ICON}/mrslotty.png`, rx: /mrslotty/i },
  { id: 'netgame', label: 'NETGAME', icon: `${ICON}/netgame.png`, rx: /netgame/i },
  { id: 'ngmgame', label: 'NGMGAME', icon: `${ICON}/ngmgame.png`, rx: /ngm/i },
  { id: 'onetouch', label: 'ONETOUCH', icon: `${ICON}/onetouch.png`, rx: /onetouch|one\s?touch/i },
  { id: 'onlyplay', label: 'ONLYPLAY', icon: `${ICON}/onlyplay.png`, rx: /onlyplay/i },
  { id: 'orbital', label: 'ORBITAL', icon: `${ICON}/orbital.png`, rx: /orbital/i },
  { id: 'peterandsons', label: 'PETERANDSONS', icon: `${ICON}/peterandsons.png`, rx: /peter\s?and\s?sons/i },
  { id: 'phoenix7', label: 'PHOENIX7', icon: `${ICON}/phoenix7.png`, rx: /phoenix/i },
  { id: 'pixmove', label: 'PIXMOVE', icon: `${ICON}/pixmove.png`, rx: /pixmove/i },
  { id: 'playhub', label: 'PLAYHUB', icon: `${ICON}/playhub.png`, rx: /playhub/i },
  { id: 'playtech', label: 'PLAYTECH', icon: `${ICON}/playtech.png`, rx: /playtech/i },
  { id: 'quickspin', label: 'QUICKSPIN', icon: `${ICON}/quickspin.png`, rx: /quickspin/i },
  { id: 'smartsoft', label: 'SMARTSOFT', icon: `${ICON}/smartsoft.png`, rx: /smartsoft/i },
  { id: 'swntt', label: 'SWNTT', icon: `${ICON}/swntt.png`, rx: /swntt/i },
  { id: 'technology', label: 'TECHNOLOGY', icon: `${ICON}/technology.png`, rx: /technology/i },
  { id: 'thunderkick', label: 'THUNDERKICK', icon: `${ICON}/thunderkick.png`, rx: /thunderkick/i },
  { id: 'thunderspin', label: 'THUNDERSPIN', icon: `${ICON}/thunderspin.png`, rx: /thunderspin/i },
  { id: 'turbogames', label: 'TURBOGAMES', icon: `${ICON}/turbogames.png`, rx: /turbo\s?games|turbogames/i },
  { id: 'urgentgames', label: 'URGENTGAMES', icon: `${ICON}/urgentgames.png`, rx: /urgent/i },
  { id: 'voltent', label: 'VOLTENT', icon: `${ICON}/voltent.png`, rx: /voltent/i },
  { id: 'zillion', label: 'ZILLION', icon: `${ICON}/zillion.png`, rx: /zillion/i },
  { id: 'jili', label: 'JILI', icon: `${ICON}/jili.png`, rx: /jili/i },
  { id: 'cq9', label: 'CQ9', icon: `${ICON}/cq9.png`, rx: /cq9/i },
  { id: 'pragmatic', label: 'PRAGMATIC', icon: `${ICON}/pragmatic.png`, rx: /pragmatic/i },
  { id: 'relax', label: 'RELAX', icon: `${ICON}/relax.png`, rx: /relax/i },
  { id: 'evolution', label: 'EVOLUTION', icon: '/imgs/playkaro/live-casino/providers/evolution.png', rx: /evolution/i },
  { id: 'ezugi', label: 'EZUGI', icon: '/imgs/playkaro/live-casino/providers/ezugi.png', rx: /ezugi/i },
  { id: 'mac88', label: 'MAC88', rx: /mac88/i },
  { id: '2j', label: '2J', rx: /\b2j\b/i },
  { id: 'v8', label: 'V8', rx: /\bv8\b/i },
]

export const PK_SLOT_SEARCH_TERMS = [
  'slot',
  'slots',
  'aviator',
  'crash',
  'fishing',
  'jackpot',
  'cricket',
  'mines',
  'plinko',
  'chicken',
  'baccarat',
  'roulette',
  'blackjack',
  'teen patti',
  'live casino',
] as const

export const PK_SLOT_LIST_PROVIDERS = [
  '100hp',
  'Spribe',
  'Netent Asia',
  'Red Tiger',
  'PG Soft',
  'JILI',
  'CQ9',
  'JDBGaming',
  'Smartsoft',
  'Turbogames',
  'InOut',
  'Evoplay',
  'Playtech',
  'Bgaming',
  'Pragmatic',
  'Hacksaw',
  'Booming',
  'Onlyplay',
  'OneTouch',
  'Fugaso',
  'Voltent',
  'RelaxGaming',
  'BigTimeGaming',
  'NoLimit City',
  'OneGaming',
  'KM',
  'Evolution Live',
  'Ezugi',
  'V8',
  '2J',
  'Mini',
  'Mac88',
  'Mac88 Gaming',
] as const

export function resolveSlotProviderIcon(id: string, label: string): string | undefined {
  const seeded = PK_SLOT_SEED_PROVIDERS.find((p) => p.id === id)
  if (seeded?.icon) return seeded.icon
  const lotus = getLotusProviderIconUrl(label, id)
  return lotus || undefined
}
